import { N as push, O as setContext, S as getContext, T as spread_attributes, V as clsx, R as bind_props, P as pop, Z as copy_payload, _ as assign_payload, Q as spread_props, a4 as fallback, a3 as slot, W as attr, a0 as stringify, X as ensure_array_like, $ as store_get, Y as escape_html, a1 as unsubscribe_stores, a5 as sanitize_props } from "./index.js";
import { B as Button, p as page } from "./stores.js";
import { c as classMap, S as SmuiElement } from "./SmuiElement.js";
import { o as onDestroy } from "./index-server.js";
import { ponyfill, events } from "@material/dom";
import "clsx";
import { MDCRippleFoundation, util } from "@material/ripple";
import { o as on } from "./events.js";
import { g as goto } from "./client.js";
import { a as analytics } from "./analytics.js";
function dispatch(element, eventType, detail, eventInit = { bubbles: true }) {
  if (typeof Event === "undefined") {
    throw new Error("Event not defined.");
  }
  if (!element) {
    throw new Error("Tried to dispatch event without element.");
  }
  const event = new CustomEvent(eventType, Object.assign(Object.assign({}, eventInit), { detail }));
  element === null || element === void 0 ? void 0 : element.dispatchEvent(event);
  return event;
}
class SvelteEventManager {
  constructor() {
    this.elementMap = /* @__PURE__ */ new Map();
  }
  /**
   * Listen to an event on an element.
   */
  on(element, event, handler, options) {
    if (!this.elementMap.has(element)) {
      this.elementMap.set(element, {});
    }
    const eventMap = this.elementMap.get(element);
    if (eventMap == null) {
      throw new Error("Event map couldn't be created.");
    }
    if (!(event in eventMap)) {
      eventMap[event] = /* @__PURE__ */ new Map();
    }
    const handlerMap = eventMap[event];
    handlerMap.set(handler, on(element, event, handler, options));
  }
  /**
   * Unlisten to an event on an element.
   */
  off(element, event, handler) {
    const eventMap = this.elementMap.get(element);
    if (eventMap == null || !(event in eventMap)) {
      return;
    }
    const handlerMap = eventMap[event];
    const unlisten = handlerMap.get(handler);
    if (unlisten != null) {
      unlisten();
      handlerMap.delete(handler);
      if (handlerMap.size === 0) {
        delete eventMap[event];
        if (Object.keys(eventMap).length === 0) {
          this.elementMap.delete(element);
        }
      }
    }
  }
  /**
   * Unlisten to all events managed by this instance.
   */
  clear() {
    this.elementMap.forEach((eventMaps, _element) => {
      for (let [_event, eventMap] of Object.entries(eventMaps)) {
        eventMap.forEach((unlisten, _handler) => {
          unlisten();
        });
      }
    });
    this.elementMap.clear();
  }
}
function MenuSurface($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    style = "",
    static: isStatic = false,
    anchor = true,
    fixed = false,
    open = isStatic,
    managed = false,
    fullWidth = false,
    quickOpen = false,
    anchorElement = void 0,
    anchorCorner,
    anchorMargin = { top: 0, right: 0, bottom: 0, left: 0 },
    maxHeight = 0,
    horizontallyCenteredOnViewport = false,
    openBottomBias = 0,
    neverRestoreFocus = false,
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let internalStyles = {};
  setContext("SMUI:list:role", "menu");
  setContext("SMUI:list:item:role", "menuitem");
  getContext("SMUI:menu-surface:mount");
  getContext("SMUI:menu-surface:unmount");
  onDestroy(() => {
  });
  function isOpen() {
    return open;
  }
  function setOpen(value) {
    open = value;
  }
  function setAbsolutePosition(x, y) {
    {
      throw new Error("Instance is not defined.");
    }
  }
  function setIsHoisted(isHoisted) {
    {
      throw new Error("Instance is not defined.");
    }
  }
  function isFixed() {
    {
      throw new Error("Instance is not defined.");
    }
  }
  function flipCornerHorizontally() {
    {
      throw new Error("Instance is not defined.");
    }
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<div${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-menu-surface": true,
      "mdc-menu-surface--fixed": fixed,
      "mdc-menu-surface--open": isStatic,
      "smui-menu-surface--static": isStatic,
      "mdc-menu-surface--fullwidth": fullWidth,
      ...internalClasses
    })),
    style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" "),
    role: "dialog",
    ...restProps
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></div>`;
  bind_props($$props, {
    open,
    anchorElement,
    isOpen,
    setOpen,
    setAbsolutePosition,
    setIsHoisted,
    isFixed,
    flipCornerHorizontally,
    getElement
  });
  pop();
}
function Menu($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    open = false,
    anchorElement = void 0,
    managed = false,
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  setContext("SMUI:menu-surface:mount", (accessor) => {
  });
  const SMUIListMount = getContext("SMUI:list:mount");
  setContext("SMUI:list:mount", (accessor) => {
    SMUIListMount && SMUIListMount(accessor);
  });
  getContext("SMUI:menu:mount");
  getContext("SMUI:menu:unmount");
  function isOpen() {
    return open;
  }
  function setOpen(value) {
    open = value;
  }
  function setDefaultFocusState(focusState) {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getSelectedIndex() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getMenuSurface() {
    return element;
  }
  function getElement() {
    return element.getElement();
  }
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    MenuSurface($$payload2, spread_props([
      {
        use,
        class: classMap({ [className]: true, "mdc-menu": true }),
        managed
      },
      restProps,
      {
        onkeydown: (e) => {
          restProps.onkeydown?.(e);
        },
        onSMUIMenuSurfaceOpened: (e) => {
          restProps.onSMUIMenuSurfaceOpened?.(e);
        },
        onSMUIListAction: (e) => {
          restProps.onSMUIListAction?.(e);
        },
        get open() {
          return open;
        },
        set open($$value) {
          open = $$value;
          $$settled = false;
        },
        get anchorElement() {
          return anchorElement;
        },
        set anchorElement($$value) {
          anchorElement = $$value;
          $$settled = false;
        },
        children: ($$payload3) => {
          children?.($$payload3);
          $$payload3.out += `<!---->`;
        },
        $$slots: { default: true }
      }
    ]));
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  bind_props($$props, {
    open,
    anchorElement,
    isOpen,
    setOpen,
    setDefaultFocusState,
    getSelectedIndex,
    getMenuSurface,
    getElement
  });
  pop();
}
function List($$payload, $$props) {
  push();
  const { closest, matches: matches2 } = ponyfill;
  let nav = getContext("SMUI:list:nav");
  let {
    use = [],
    class: className = "",
    nonInteractive = false,
    dense = false,
    textualList = false,
    avatarList = false,
    iconList = false,
    imageList = false,
    thumbnailList = false,
    videoList = false,
    twoLine = false,
    threeLine = false,
    vertical = true,
    wrapFocus = getContext("SMUI:list:wrapFocus") ?? false,
    singleSelection = false,
    disabledItemsFocusable = false,
    selectedIndex = -1,
    radioList = false,
    checkList = false,
    hasTypeahead = false,
    component: MyComponent = SmuiElement,
    tag = nav ? "nav" : "ul",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let items = [];
  let role = getContext("SMUI:list:role");
  const itemAccessorMap = /* @__PURE__ */ new WeakMap();
  let selectionDialog = getContext("SMUI:dialog:selection");
  let addLayoutListener = getContext("SMUI:addLayoutListener");
  let removeLayoutListener;
  setContext("SMUI:list:nonInteractive", nonInteractive);
  setContext("SMUI:separator:context", "list");
  if (!role) {
    if (singleSelection) {
      role = "listbox";
      setContext("SMUI:list:item:role", "option");
    } else if (radioList) {
      role = "radiogroup";
      setContext("SMUI:list:item:role", "radio");
    } else if (checkList) {
      role = "group";
      setContext("SMUI:list:item:role", "checkbox");
    } else {
      role = "list";
      setContext("SMUI:list:item:role", void 0);
    }
  }
  if (addLayoutListener) {
    removeLayoutListener = addLayoutListener(layout);
  }
  setContext("SMUI:list:item:mount", (accessor) => {
    items.push(accessor);
    itemAccessorMap.set(accessor.element, accessor);
    if (singleSelection && accessor.selected) {
      selectedIndex = getListItemIndex(accessor.element);
    }
  });
  setContext("SMUI:list:item:unmount", (accessor) => {
    const idx = (accessor && items.findIndex((a) => a === accessor)) ?? -1;
    if (idx !== -1) {
      items.splice(idx, 1);
      itemAccessorMap.delete(accessor.element);
    }
  });
  getContext("SMUI:list:mount");
  getContext("SMUI:list:unmount");
  onDestroy(() => {
    if (removeLayoutListener) {
      removeLayoutListener();
    }
  });
  function handleAction(event) {
    if (radioList || checkList) {
      const index = getListItemIndex(event.target);
      if (index !== -1) {
        const item = getOrderedList()[index];
        if (item && (radioList && !item.checked || checkList)) {
          if (!matches2(event.detail.target, 'input[type="checkbox"], input[type="radio"]')) {
            item.checked = !item.checked;
          }
          item.activateRipple();
          window.requestAnimationFrame(() => {
            item.deactivateRipple();
          });
        }
      }
    }
  }
  function getOrderedList() {
    {
      return [];
    }
  }
  function getListItemIndex(element2) {
    const nearestParent = closest(element2, ".mdc-deprecated-list-item, .mdc-deprecated-list");
    if (nearestParent && matches2(nearestParent, ".mdc-deprecated-list-item")) {
      return getOrderedList().map((item) => item?.element).indexOf(nearestParent);
    }
    return -1;
  }
  function layout() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function setEnabled(itemIndex, isEnabled) {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getTypeaheadInProgress() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getSelectedIndex() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getFocusedItemIndex() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function focusItemAtIndex(index) {
    const accessor = getOrderedList()[index];
    accessor && "focus" in accessor.element && accessor.element.focus();
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-deprecated-list": true,
        "mdc-deprecated-list--non-interactive": nonInteractive,
        "mdc-deprecated-list--dense": dense,
        "mdc-deprecated-list--textual-list": textualList,
        "mdc-deprecated-list--avatar-list": avatarList || selectionDialog,
        "mdc-deprecated-list--icon-list": iconList,
        "mdc-deprecated-list--image-list": imageList,
        "mdc-deprecated-list--thumbnail-list": thumbnailList,
        "mdc-deprecated-list--video-list": videoList,
        "mdc-deprecated-list--two-line": twoLine,
        "smui-list--three-line": threeLine && !twoLine
      }),
      role
    },
    restProps,
    {
      onkeydown: (e) => {
        restProps.onkeydown?.(e);
      },
      onfocusin: (e) => {
        restProps.onfocusin?.(e);
      },
      onfocusout: (e) => {
        restProps.onfocusout?.(e);
      },
      onclick: (e) => {
        restProps.onclick?.(e);
      },
      onSMUIAction: (e) => {
        handleAction(e);
        restProps.onSMUIAction?.(e);
      },
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, {
    selectedIndex,
    layout,
    setEnabled,
    getTypeaheadInProgress,
    getSelectedIndex,
    getFocusedItemIndex,
    focusItemAtIndex,
    getElement
  });
  pop();
}
const { applyPassive } = events;
const { matches } = ponyfill;
function Ripple(node, { ripple = true, surface = false, unbounded = false, disabled = false, color, active, rippleElement, eventTarget, activeTarget, addClass = (className) => node.classList.add(className), removeClass = (className) => node.classList.remove(className), addStyle = (name, value) => node.style.setProperty(name, value), initPromise = Promise.resolve() } = {}) {
  let instance;
  let eventManager = new SvelteEventManager();
  let addLayoutListener = getContext("SMUI:addLayoutListener");
  let removeLayoutListener;
  let oldActive = active;
  let oldEventTarget = eventTarget;
  let oldActiveTarget = activeTarget;
  function handleProps() {
    if (surface) {
      addClass("mdc-ripple-surface");
      if (color === "primary") {
        addClass("smui-ripple-surface--primary");
        removeClass("smui-ripple-surface--secondary");
      } else if (color === "secondary") {
        removeClass("smui-ripple-surface--primary");
        addClass("smui-ripple-surface--secondary");
      } else {
        removeClass("smui-ripple-surface--primary");
        removeClass("smui-ripple-surface--secondary");
      }
    } else {
      removeClass("mdc-ripple-surface");
      removeClass("smui-ripple-surface--primary");
      removeClass("smui-ripple-surface--secondary");
    }
    if (instance && oldActive !== active) {
      oldActive = active;
      if (active) {
        instance.activate();
      } else if (active === false) {
        instance.deactivate();
      }
    }
    if (ripple && !instance) {
      instance = new MDCRippleFoundation({
        addClass,
        browserSupportsCssVars: () => util.supportsCssVariables(window),
        computeBoundingRect: () => (rippleElement || node).getBoundingClientRect(),
        containsEventTarget: (target) => node.contains(target),
        deregisterDocumentInteractionHandler: (evtType, handler) => eventManager.off(document.documentElement, evtType, handler),
        deregisterInteractionHandler: (evtType, handler) => eventManager.off(eventTarget || node, evtType, handler),
        deregisterResizeHandler: (handler) => window.removeEventListener("resize", handler),
        getWindowPageOffset: () => {
          var _a, _b;
          return {
            x: (_a = window.pageXOffset) !== null && _a !== void 0 ? _a : window.scrollX,
            y: (_b = window.pageYOffset) !== null && _b !== void 0 ? _b : window.scrollY
          };
        },
        isSurfaceActive: () => active == null ? matches(activeTarget || node, ":active") : active,
        isSurfaceDisabled: () => !!disabled,
        isUnbounded: () => !!unbounded,
        registerDocumentInteractionHandler: (evtType, handler) => {
          const opts = applyPassive();
          eventManager.on(document.documentElement, evtType, handler, typeof opts === "boolean" ? { capture: opts } : opts);
        },
        registerInteractionHandler: (evtType, handler) => {
          const opts = applyPassive();
          eventManager.on(eventTarget || node, evtType, handler, typeof opts === "boolean" ? { capture: opts } : opts);
        },
        registerResizeHandler: (handler) => eventManager.on(window, "resize", handler),
        removeClass,
        updateCssVariable: addStyle
      });
      initPromise.then(() => {
        if (instance) {
          instance.init();
          instance.setUnbounded(unbounded);
        }
      });
    } else if (instance && !ripple) {
      initPromise.then(() => {
        if (instance) {
          instance.destroy();
          instance = void 0;
          eventManager.clear();
        }
      });
    }
    if (instance && (oldEventTarget !== eventTarget || oldActiveTarget !== activeTarget)) {
      oldEventTarget = eventTarget;
      oldActiveTarget = activeTarget;
      instance.destroy();
      requestAnimationFrame(() => {
        if (instance) {
          instance.init();
          instance.setUnbounded(unbounded);
        }
      });
    }
    if (!ripple && unbounded) {
      addClass("mdc-ripple-upgraded--unbounded");
    }
  }
  handleProps();
  if (addLayoutListener) {
    removeLayoutListener = addLayoutListener(layout);
  }
  function layout() {
    if (instance) {
      instance.layout();
    }
  }
  return {
    update(props) {
      ({
        ripple,
        surface,
        unbounded,
        disabled,
        color,
        active,
        rippleElement,
        eventTarget,
        activeTarget,
        addClass,
        removeClass,
        addStyle,
        initPromise
      } = Object.assign({ ripple: true, surface: false, unbounded: false, disabled: false, color: void 0, active: void 0, rippleElement: void 0, eventTarget: void 0, activeTarget: void 0, addClass: (className) => node.classList.add(className), removeClass: (className) => node.classList.remove(className), addStyle: (name, value) => node.style.setProperty(name, value), initPromise: Promise.resolve() }, props));
      handleProps();
    },
    destroy() {
      if (instance) {
        instance.destroy();
        instance = void 0;
        eventManager.clear();
        removeClass("mdc-ripple-surface");
        removeClass("smui-ripple-surface--primary");
        removeClass("smui-ripple-surface--secondary");
      }
      if (removeLayoutListener) {
        removeLayoutListener();
      }
    }
  };
}
let counter = 0;
function Item($$payload, $$props) {
  push();
  let uninitializedValue = () => {
  };
  function isUninitializedValue(value) {
    return value === uninitializedValue;
  }
  let nav = getContext("SMUI:list:item:nav");
  let {
    use = [],
    class: className = "",
    style = "",
    color,
    nonInteractive = getContext("SMUI:list:nonInteractive") ?? false,
    ripple = !nonInteractive,
    wrapper = false,
    activated = false,
    role = wrapper ? "presentation" : getContext("SMUI:list:item:role"),
    selected = false,
    disabled = false,
    skipRestoreFocus = false,
    tabindex: tabindexProp = uninitializedValue,
    inputId = "SMUI-form-field-list-" + counter++,
    href,
    component: MyComponent = SmuiElement,
    tag = nav ? href ? "a" : "span" : "li",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  setContext("SMUI:list:nonInteractive", void 0);
  setContext("SMUI:list:item:role", void 0);
  let element;
  let internalClasses = {};
  let internalStyles = {};
  let internalAttrs = {};
  let input = void 0;
  const tabindex = isUninitializedValue(tabindexProp) ? !nonInteractive && !disabled && (selected || input && input.checked) ? 0 : -1 : tabindexProp;
  setContext("SMUI:generic:input:props", { id: inputId });
  setContext("SMUI:separator:context", void 0);
  setContext("SMUI:generic:input:mount", (accessor) => {
    if ("_smui_checkbox_accessor" in accessor || "_smui_radio_accessor" in accessor) {
      input = accessor;
    }
  });
  setContext("SMUI:generic:input:unmount", () => {
    input = void 0;
  });
  getContext("SMUI:list:item:mount");
  getContext("SMUI:list:item:unmount");
  onDestroy(() => {
  });
  function addClass(className2) {
    if (!internalClasses[className2]) {
      internalClasses[className2] = true;
    }
  }
  function removeClass(className2) {
    if (!(className2 in internalClasses) || internalClasses[className2]) {
      internalClasses[className2] = false;
    }
  }
  function addStyle(name, value) {
    if (internalStyles[name] != value) {
      if (value === "" || value == null) {
        delete internalStyles[name];
      } else {
        internalStyles[name] = value;
      }
    }
  }
  function handleKeydown(e) {
    const isEnter = e.key === "Enter";
    const isSpace = e.key === "Space";
    if (isEnter || isSpace) {
      action(e);
    }
  }
  function action(e) {
    if (!disabled) {
      dispatch(getElement(), "SMUIAction", e);
    }
  }
  function getPrimaryText() {
    const element2 = getElement();
    const primaryText = element2.querySelector(".mdc-deprecated-list-item__primary-text");
    if (primaryText) {
      return primaryText.textContent ?? "";
    }
    const text = element2.querySelector(".mdc-deprecated-list-item__text");
    if (text) {
      return text.textContent ?? "";
    }
    return element2.textContent ?? "";
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use: [
        ...nonInteractive ? [] : [
          [
            Ripple,
            {
              ripple: !input,
              unbounded: false,
              color: (activated || selected) && color == null ? "primary" : color,
              disabled,
              addClass,
              removeClass,
              addStyle
            }
          ]
        ],
        ...use
      ],
      class: classMap({
        [className]: true,
        "mdc-deprecated-list-item": !wrapper,
        "mdc-deprecated-list-item__wrapper": wrapper,
        "mdc-deprecated-list-item--activated": activated,
        "mdc-deprecated-list-item--selected": selected,
        "mdc-deprecated-list-item--disabled": disabled,
        "mdc-menu-item--selected": !nav && role === "menuitem" && selected,
        "smui-menu-item--non-interactive": nonInteractive,
        ...internalClasses
      }),
      style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" ")
    },
    nav && activated ? { "aria-current": "page" } : {},
    !nav || wrapper ? { role } : {},
    !nav && role === "option" ? { "aria-selected": selected ? "true" : "false" } : {},
    !nav && (role === "radio" || role === "checkbox") ? {
      "aria-checked": input && input.checked ? "true" : "false"
    } : {},
    !nav ? { "aria-disabled": disabled ? "true" : "false" } : {},
    {
      "data-menu-item-skip-restore-focus": skipRestoreFocus || void 0,
      tabindex,
      href
    },
    internalAttrs,
    restProps,
    {
      onclick: (e) => {
        action(e);
        restProps.onclick?.(e);
      },
      onkeydown: (e) => {
        handleKeydown(e);
        restProps.onkeydown?.(e);
      },
      children: ($$payload2) => {
        if (ripple) {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<span class="mdc-deprecated-list-item__ripple"></span>`;
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]-->`;
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, {
    activated,
    selected,
    tabindex: tabindexProp,
    action,
    getPrimaryText,
    getElement
  });
  pop();
}
function Portal($$payload, $$props) {
  push();
  let target = fallback($$props["target"], "body");
  $$payload.out += `<div hidden><!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----></div>`;
  bind_props($$props, { target });
  pop();
}
function PurchaseButton($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  var $$store_subs;
  let buttonRef;
  let isOpen = false;
  let size = fallback($$props["size"], 0);
  let width = fallback($$props["width"], 0);
  let containerClass = fallback($$props["containerClass"], "");
  let menuClass = fallback($$props["menuClass"], "");
  let context = fallback($$props["context"], "default");
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    $$payload2.out += `<div${attr("class", `flex flex-col ${stringify(containerClass)}`)}>`;
    Button($$payload2, spread_props([
      {
        size,
        startIcon: "mdi:shopping",
        endIcon: isOpen ? "mdi:chevron-up" : "mdi:chevron-down",
        label: "Buy Glimmr Pro",
        secondaryLabel: "Lifetime license: Choose your price"
      },
      $$sanitized_props,
      {
        get ref() {
          return buttonRef;
        },
        set ref($$value) {
          buttonRef = $$value;
          $$settled = false;
        },
        get offsetWidth() {
          return width;
        },
        set offsetWidth($$value) {
          width = $$value;
          $$settled = false;
        }
      }
    ]));
    $$payload2.out += `<!----> `;
    Portal($$payload2, {
      children: ($$payload3) => {
        Menu($$payload3, {
          anchor: false,
          anchorElement: buttonRef,
          anchorCorner: "BOTTOM_LEFT",
          class: `my-2 z-50 rounded-2xl ${stringify(menuClass)}`,
          style: `min-width: ${stringify(width)}px;`,
          get open() {
            return isOpen;
          },
          set open($$value) {
            isOpen = $$value;
            $$settled = false;
          },
          children: ($$payload4) => {
            List($$payload4, {
              children: ($$payload5) => {
                const each_array = ensure_array_like(store_get($$store_subs ??= {}, "$page", page).data.prices);
                $$payload5.out += `<!--[-->`;
                for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
                  let price = each_array[$$index];
                  const handlePriceClick = () => {
                    analytics.track("start_checkout", { price });
                    goto();
                  };
                  Item($$payload5, {
                    onSMUIAction: handlePriceClick,
                    class: "font-medium",
                    children: ($$payload6) => {
                      $$payload6.out += `<!---->$${escape_html(price)}`;
                    },
                    $$slots: { default: true }
                  });
                }
                $$payload5.out += `<!--]-->`;
              },
              $$slots: { default: true }
            });
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, {
    size,
    width,
    containerClass,
    menuClass,
    context
  });
  pop();
}
export {
  Item as I,
  List as L,
  PurchaseButton as P,
  Ripple as R,
  SvelteEventManager as S,
  dispatch as d
};
